export default "/images/3f7ec39fc609163cd27f3f69b47d69b8.avif";